var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('p',[_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear())+", "+_vm._s(_vm.company)+". Alle Rechte vorbehalten.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }